//using for pricing cards features list icon
import React from 'react';
import { makeStyles, createStyles,Theme} from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';

const iconImage = require("../../images/checkedicon.png")
// import FormLabel from '@material-ui/core/FormLabel';
const useStyles = makeStyles((theme: Theme) => 
  createStyles({
    main:{
      transition:'none',
      '&.hover':{
        backgroundColor:'transparent !important',
      },
      '&.MuiFormControlLabel-root':{
        cursor: 'unset',
        height:'1.5em'
      },
      '&.MuiRadio-root': {
        color: 'transparent',
        '&.hover':{
          backgroundColor:'transparent',
        }
    },
    
    },
    radioicon:{
      '&.MuiRadio-root': {
        color: '#ED5565'
    
    },
    },
    radioGroup:{
      '&.MuiFormGroup-root':{
        marginTop:'1em'
      },
     
    },
    radio:{
      '&$checked': {
        color: '#4B8DF8'
      },
      '&:hover': {
        background: 'none',
      },
      '&.MuiRadio-root':{
        '&hover':{
          backgroundColor:'transparent'
          }
      }
     
    }
  })
);
export default function RadioButtonsGroup(props:any) {
  const [value,] = React.useState('');
  const classes = useStyles();

  {/* const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  }; */}

  return (
    <FormControl component="fieldset">
      {props.lable4?
        <RadioGroup aria-label="pricing" name="pricinfeatures" value={value} className={classes.radioGroup} >
           <FormControlLabel value="features1" control={<Radio className={classes.radioicon} />} label={props.lable1} className={classes.main} />
           <FormControlLabel value="features2" control={<Radio icon={iconImage} className={classes.radioicon} />} label={props.lable2} className={classes.main}/>
           <FormControlLabel value="features3" control={<Radio className={classes.radioicon} />} label={props.lable3} className={classes.main}/>
           <FormControlLabel value="features4" control={<Radio className={classes.radioicon}/>} label={props.lable4} className={classes.main}/>
        </RadioGroup>:
        <RadioGroup aria-label="pricing" name="pricinfeatures" value={value} className={classes.radioGroup} >
           <FormControlLabel value="features1" control={<Radio disableRipple icon={<CheckCircleOutlineOutlinedIcon style={{fontSize:'small'}}/>} checkedIcon={<CheckCircleOutlineOutlinedIcon style={{fontSize:'small'}} />} className={classes.radio} />} label={props.lable1} className={classes.main}/>
           <FormControlLabel value="features2" control={<Radio disableRipple icon={<CheckCircleOutlineOutlinedIcon style={{fontSize:'small'}}/>} checkedIcon={<CheckCircleOutlineOutlinedIcon style={{fontSize:'small'}} />} className={classes.radio} />} label={props.lable2} className={classes.main}/>
           <FormControlLabel value="features3" control={<Radio disableRipple icon={<CheckCircleOutlineOutlinedIcon style={{fontSize:'small'}}/>} checkedIcon={<CheckCircleOutlineOutlinedIcon style={{fontSize:'small'}} />} className={classes.radio} />} label={props.lable3} className={classes.main}/>
           <FormControlLabel value="features3" control={<Radio disableRipple icon={<CheckCircleOutlineOutlinedIcon style={{fontSize:'small'}}/>} checkedIcon={<CheckCircleOutlineOutlinedIcon style={{fontSize:'small'}} />} className={classes.radio} />} label={props.lable5} className={classes.main}/>
        </RadioGroup>
      }
   </FormControl>
  );
}
